/**
 * @fileoverview This file contains the definition of AngularJS module 'app.newresources' and its factories.
 * The module provides caching functionality using CacheFactory and defines two factories: 'auth_factory' and 'user_factory'.
 * The 'auth_factory' factory provides methods for authentication-related API calls.
 * The 'user_factory' factory provides methods for user-related API calls and utilizes caching.
 */
(function () {
    'use strict';

    angular
        .module('app.newresources', []).run(['CacheFactory', function (CacheFactory) {
            var storageImpl = {
                getItem: function (key) { return localStorage.getItem(key); },
                setItem: function (key, value, storage) {
                    try {
                        return localStorage.setItem(key, value);
                    } catch (err) {
                        const accessToken = localStorage.getItem('accessToken');
                        const accessTokenExpires = localStorage.getItem('accessTokenExpires');
                        const refreshToken = localStorage.getItem('refreshToken');
                        const refreshTokenExpires = localStorage.getItem('refreshTokenExpires');
                        localStorage.clear();
                        localStorage.setItem('accessToken', accessToken);
                        localStorage.setItem('accessTokenExpires', accessTokenExpires);
                        localStorage.setItem('refreshToken', refreshToken);
                        localStorage.setItem('refreshTokenExpires', refreshTokenExpires);
                        window.userStorage.sync();
                        return localStorage.setItem(key, value);
                    }
                },
                removeItem: function (key) { return localStorage.removeItem(key); },
            };
            if (!CacheFactory.get('Products')) {
                CacheFactory('Products', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 48 * 60 * 60 * 1000,
                    // storageImpl: storageImpl,
                    cacheFlushInterval: 48 * 60 * 60 * 1000
                });
            }
            if (!CacheFactory.get('BlogList')) {
                CacheFactory('BlogList', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    // storageImpl: storageImpl,
                    cacheFlushInterval: 24 * 60 * 60 * 1000
                });
            }
            if (!CacheFactory.get('BlogGet')) {
                CacheFactory('BlogGet', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    // storageImpl: storageImpl,
                    cacheFlushInterval: 24 * 60 * 60 * 1000
                });
            }
            if (!CacheFactory.get('BlogCategory')) {
                CacheFactory('BlogCategory', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 48 * 60 * 60 * 1000,
                    storageImpl: storageImpl,
                    cacheFlushInterval: 48 * 60 * 60 * 1000
                });
            }
            if (!CacheFactory.get('UserCache')) {
                CacheFactory('UserCache', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 5 * 60 * 1000, storageImpl: storageImpl,
                    cacheFlushInterval: 5 * 60 * 1000
                });
            }
            if (!CacheFactory.get('UserInfo')) {
                CacheFactory('UserInfo', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 5 * 60 * 1000, storageImpl: storageImpl,
                    cacheFlushInterval: 5 * 60 * 1000
                });
            }
            if (!CacheFactory.get('NotificationList')) {
                CacheFactory('NotificationList', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 5 * 60 * 1000, storageImpl: storageImpl,
                    cacheFlushInterval: 5 * 60 * 1000
                });
            }
            if (!CacheFactory.get('UserProducts')) {
                CacheFactory('UserProducts', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 5 * 60 * 1000, storageImpl: storageImpl,
                    cacheFlushInterval: 5 * 60 * 1000
                });
            }
        }])
        .factory('auth_factory', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NEW + '/:root/:dest', {}, {
                    login: {
                        method: 'POST',
                        params: { dest: "", root: "auth" },
                        isArray: false
                    },
                    registerandlogin: {
                        method: 'POST',
                        params: { dest: "registerandlogin", root: "auth" },
                        isArray: false
                    },
                    login2fa: {
                        method: 'POST',
                        params: { dest: "login", root: "auth" },
                        isArray: false,
                        ignoreLoadingBar: false
                    },
                    refresh: {
                        method: 'POST',
                        params: { dest: "refreshtoken", root: "auth" },
                        isArray: false,
                        ignoreLoadingBar: false
                    },
                    externallogins: {
                        method: 'GET',
                        params: { dest: "externallogins", root: "auth" },
                        isArray: true,
                        ignoreLoadingBar: true
                    },
                    logout: {
                        method: 'POST',
                        params: { dest: "logout", root: "auth" },
                        isArray: false,
                        ignoreLoadingBar: false
                    },
                    del_info_finger: {
                        method: 'DELETE',
                        params: { root: "authuserfingerprint", dest: "deleteuserfingerprintinfo" },
                        cache: false,
                        ignoreLoadingBar: true
                    },
                    get_info_finger: {
                        method: 'GET',
                        params: { root: "authuserfingerprint", dest: "getuserfingerprintinfo" },
                        isArray: true,
                        cache: false,
                        ignoreLoadingBar: true,
                        timeout: 3000
                    },
                    set_info_finger: {
                        method: 'GET',
                        params: { root: "authuserfingerprint", dest: "setuserfingerprintinfo" },
                        isArray: false,
                        cache: false,
                        ignoreLoadingBar: true,
                        timeout: 3000
                    },
                    get_finger: {
                        method: 'GET',
                        params: { root: "authuserfingerprint" },
                        isArray: false,
                        cache: false,
                        ignoreLoadingBar: true,
                        timeout: 3000
                    },
                    set_finger: {
                        method: 'POST',
                        params: { root: "authuserfingerprint" },
                        isArray: false,
                        ignoreLoadingBar: true,
                        timeout: 3000
                    },
                    delete_finger: {
                        method: 'DELETE',
                        params: { root: "authuserfingerprint" },
                        isArray: false,
                        ignoreLoadingBar: true,
                        timeout: 3000
                    },
                    get_confirm: {
                        method: 'GET',
                        params: { root: "useremailconfirmation" },
                        isArray: false,
                        ignoreLoadingBar: false
                    },
                    set_confirm: {
                        method: 'POST',
                        params: { root: "useremailconfirmation" },
                        isArray: false,
                        ignoreLoadingBar: false
                    },
                    forgot_password: {
                        method: 'POST',
                        params: { dest: "newtoken", root: "userforgotpassword" },
                        isArray: false
                    },
                    change_password: {
                        method: 'POST',
                        params: { dest: "changepassword", root: "userforgotpassword" },
                        isArray: false
                    },
                    verify_token: {
                        method: 'POST',
                        params: { dest: "verifyexternallogin", root: "auth" },
                        isArray: false,
                        ignoreLoadingBar: false
                    },
                    external_login_confirm: {
                        method: 'POST',
                        params: { dest: "IsExternalLoginAdditionalConfirmationRequired", root: "auth" },
                        isArray: false,
                        ignoreLoadingBar: false,
                        transformResponse: function (response) {
                            return { isRequired: response === "true" };
                        }
                    },
                    sendverificationcode: {
                        method: 'POST',
                        params: { dest: "sendverificationcode", root: "auth" },
                        isArray: false,
                        ignoreLoadingBar: false
                    },
                    verification2fa: {
                        method: 'POST',
                        params: { dest: "verification", root: "auth" },
                        isArray: false,
                        ignoreLoadingBar: false
                    },
                    sendcode: {
                        method: 'POST',
                        params: { dest: "sevc", root: "auth" },
                        isArray: false,
                        ignoreLoadingBar: false
                    },
                    checkuserandverifycode: {
                        method: 'POST',
                        params: { dest: "checkuserandverifycode", root: "auth" },
                        isArray: false,
                        ignoreLoadingBar: false
                    },
                    verify_partner_login: {
                        method: 'POST',
                        params: {
                            root: 'auth',
                            dest: 'VerifyPartnerLogin',
                        },
                        isArray: false
                    },
                    getBankUserDetails: {
                        method: 'GET',
                        params: { root: 'auth', dest: 'GetBankUserDetails', token: '@token' },
                        cache: false,
                        isArray: false,
                        transformResponse: function (response) {
                            let cipherText = JSON.parse(response);
                            return JSON.parse(window.encodeResponse(cipherText));
                        }
                    },
                    emlakjetLogin: {
                        method: 'GET',
                        params: { root: 'auth', dest: 'EmlakjetLogin' },
                        cache: false,
                        isArray: false
                    },
                    emlakjetCallback: {
                        method: 'POST',
                        params: { root: 'auth', dest: 'emlakjetcallback' },
                        cache: false,
                        isArray: false
                    }
                });
            }
        ])
        .factory('oauth_factory', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NEW + '/oauth/:root/:dest', {}, {
                    oauthAuthorize: {
                        method: 'GET',
                        params: { root: 'authorize' },
                        cache: false,
                        isArray: false
                    },
                    oauthApprove: {
                        method: 'POST',
                        params: { root: 'authorize', dest: 'approve' },
                        cache: false,
                        isArray: false
                    },
                    oauthDeny: {
                        method: 'POST',
                        params: { root: 'authorize', dest: 'deny' },
                        cache: false,
                        isArray: false
                    },
                    checkConsent: {
                        method: 'GET',
                        params: { root: 'authorize', dest: 'check-consent' },
                        cache: false,
                        isArray: false
                    }
                });
            }
        ])
        .factory('captcha_factory', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NEW + '/ImageCaptcha', {}, {
                    getCaptcha: {
                        method: 'GET',
                        isArray: false,
                        cache: false,
                        ignoreLoadingBar: true
                    },
                    validateCaptcha: {
                        method: 'POST',
                        isArray: false,
                        ignoreLoadingBar: true
                    }
                });
            }
        ])
        .factory('user_factory', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var UserCache = CacheFactory.get('UserCache');

                return $resource(appSettingsSvc.NEW + '/:root/:dest', {}, {
                    eids_confirm: {
                        method: 'POST',
                        params: { root: "users", dest: "eids" },
                        isArray: false,
                    },
                    eids_check: {
                        method: 'GET',
                        params: { root: "users", dest: "EidsStatus" },
                        isArray: false,
                        cache: false
                    },
                    eids_property_check: {
                        method: 'POST',
                        params: { root: "users", dest: "EidsPropertyVerification" },
                        isArray: false,
                        cache: false
                    },
                    get: {
                        method: 'GET',
                        params: { root: "users" },
                        isArray: false,
                        cache: false
                    },
                    create: {
                        method: 'POST',
                        params: { root: "users" },
                        isArray: false
                    },
                    create_external: {
                        method: 'POST',
                        params: { root: "users", dest: "createuserfromexternal" },
                        isArray: false
                    },
                    update: {
                        method: 'PUT',
                        params: { root: "users" },
                        isArray: false
                    },
                    update_byid: {
                        method: 'PUT',
                        params: { root: "users", dest: "updateuserbyid" },
                        isArray: false
                    },
                    update_phone: {
                        method: 'POST',
                        params: { root: "verification", dest: "sevc" },
                        isArray: false,
                    },
                    verify_phone: {
                        method: 'POST',
                        params: { root: "verification", dest: "validatecode" },
                        isArray: false,
                    },
                    delete: {
                        method: 'DELETE',
                        params: { root: "users" },
                        isArray: false
                    },
                    delete_byid: {
                        method: 'DELETE',
                        params: { root: "users", dest: "deleteuserbyid" },
                        isArray: false
                    },
                    me: {
                        method: 'GET',
                        params: { root: "users", dest: "me" },
                        isArray: false,
                        cache: UserCache,
                        ignoreLoadingBar: true,
                        timeout: 3000
                    },
                    search: {
                        method: 'POST',
                        params: { root: "users", dest: "search" },
                        isArray: false
                    },
                    any: {
                        method: 'GET',
                        params: { root: "users", dest: "anyuser" },
                        isArray: false,
                        cache: false
                    },
                    update_role: {
                        method: 'POST',
                        params: { root: "users", dest: "updateuserrole" },
                        isArray: false
                    },
                    create_api: {
                        method: 'POST',
                        params: { root: "users", dest: "createapitoken" },
                        isArray: false
                    },
                    update_api: {
                        method: 'POST',
                        params: { root: "users", dest: "updateapitoken" },
                        isArray: false
                    },
                    delete_api: {
                        method: 'POST',
                        params: { root: "users", dest: "deleteapitoken" },
                        isArray: false
                    },
                    change_password: {
                        method: 'POST',
                        params: { root: "users", dest: "changepassword" },
                        isArray: false
                    },
                    unblock: {
                        method: 'GET',
                        params: { root: "users", dest: "unblock" },
                        isArray: false,
                        cache: false
                    },
                    send_unblock_mail: {
                        method: 'POST',
                        params: { root: "users", dest: "sendunblockemail" },
                        isArray: false
                    },
                    last_logins: {
                        method: 'GET',
                        params: { root: "users", dest: "lastlogins" },
                        isArray: false,
                        cache: false,
                        ignoreLoadingBar: true
                    },
                    user_last_logins: {
                        method: 'GET',
                        params: { root: "users", dest: "userlastlogins" },
                        isArray: false,
                        cache: false,
                        ignoreLoadingBar: true
                    },
                    get_address: {
                        method: 'POST',
                        params: { root: "useraddresses" },
                        isArray: false
                    },
                    get_user_address: {
                        method: 'GET',
                        params: { root: "useraddresses", dest: "byuser" },
                        isArray: true,
                        cache: false
                    },
                    list_address: {
                        method: 'GET',
                        params: { root: "useraddresses", dest: "list" },
                        isArray: true,
                        cache: false,
                        ignoreLoadingBar: true
                    },
                    set_address: {
                        method: 'POST',
                        params: { root: "useraddresses", dest: "" },
                        isArray: false
                    },
                    set_address_external: {
                        method: 'POST',
                        params: { root: "useraddresses", dest: "createaddressfromexternal" },
                        isArray: false
                    },
                    del_address: {
                        params: { root: "useraddresses" },
                        method: 'DELETE'
                    },
                    upload_avatar: {
                        method: 'POST',
                        params: { dest: "", root: "useravatarupload" },
                        isArray: false
                    },
                    upload_certificate: {
                        method: 'POST',
                        params: { dest: "", root: "usercertificateupload" },
                        isArray: false
                    },
                    upload_certificate_by_userid: {
                        method: 'POST',
                        params: { dest: "adminpost", root: "usercertificateupload" },
                        isArray: false
                    },
                    submit_certificates: {
                        method: 'POST',
                        params: { dest: "addcertificates", root: "users" },
                        isArray: false
                    },
                    submit_certificates_by_userid: {
                        method: 'POST',
                        params: { dest: "addcertificatesbyuserid", root: "users" },
                        isArray: false
                    },
                    list_certificates: {
                        method: 'GET',
                        params: { dest: "getcertificatesbyuserid", root: "users" },
                        isArray: false,
                        cache: false,
                        ignoreLoadingBar: true
                    },
                    delete_certificate: {
                        method: 'DELETE',
                        params: { dest: "deletecertificate", root: "users" },
                        isArray: false
                    },
                    delete_certificate_by_userid: {
                        method: 'DELETE',
                        params: { dest: "deletecertificatebyuserid", root: "users" },
                        isArray: false
                    },
                    upload_logo: {
                        method: 'POST',
                        params: { dest: "", root: "userofficelogoupload" },
                        isArray: false
                    },
                    get_all_notes: {
                        method: 'POST',
                        params: { root: "usernotes", dest: "list" },
                        isArray: false,
                        cache: false,
                        ignoreLoadingBar: true
                    },
                    get_notes: {
                        method: 'GET',
                        params: { root: "usernotes" },
                        isArray: false,
                        cache: false,
                        ignoreLoadingBar: true
                    },
                    update_notes: {
                        method: 'PUT',
                        params: { root: "usernotes" },
                        isArray: false
                    },
                    set_notes: {
                        method: 'POST',
                        params: { root: "usernotes" },
                        isArray: false
                    },
                    del_notes: {
                        params: { root: "usernotes" },
                        method: 'DELETE'
                    },
                    get_products: {
                        method: 'GET',
                        params: { root: "userproducts" },
                        isArray: false,
                        ignoreLoadingBar: true
                    },
                    get_product: {
                        method: 'GET',
                        params: { dest: "details", root: "userproducts" },
                        isArray: false,
                        ignoreLoadingBar: true
                    },
                    listing_profiles: {
                        method: 'GET',
                        params: { root: "users", dest: "listingprofiles" },
                        isArray: false,
                        cache: false,
                        ignoreLoadingBar: true
                    },
                    add_profile: {
                        method: 'POST',
                        params: { root: "users", dest: "addlistingprofile" },
                        isArray: false,
                        cache: false
                    },
                    delete_profile: {
                        method: 'DELETE',
                        params: { root: "users", dest: "deletelistingprofile" },
                        isArray: false,
                        cache: false
                    },
                    password_status: {
                        method: 'GET',
                        params: { root: "users", dest: "getpasswordexpiredstatus" },
                        isArray: false,
                        cache: false,
                        ignoreLoadingBar: true
                    },
                    language: {
                        method: 'PUT',
                        params: { root: "users", dest: "language" },
                        hasBody: false,
                        isArray: false,
                        cache: false,
                        ignoreLoadingBar: true
                    },
                    currency: {
                        method: 'PUT',
                        params: { root: "users", dest: "currency" },
                        hasBody: false,
                        isArray: false,
                        cache: false,
                        ignoreLoadingBar: true
                    },
                    sendTempPassword: {
                        method: 'PUT',
                        params: { root: "users", dest: "settemppassword" },
                        hasBody: false,
                        isArray: false,
                        cache: false,
                        ignoreLoadingBar: true
                    },
                    getPhoneData: {
                        method: 'GET',
                        params: { root: "users", dest: "getuserphoneshowntrends" },
                        isArray: false,
                        cache: false,
                        ignoreLoadingBar: true
                    },
                    refreshClientId: {
                        method: 'PUT',
                        params: { root: "users", dest: "GoogleClientId" },
                        isArray: false,
                        cache: false,
                        ignoreLoadingBar: true
                    },
                    getConsInfo: {
                        method: 'GET',
                        isArray: false,
                        params: { root: "users", dest: "getconsultancyuserinfo" }
                    },
                    getForOpp: {
                        method: 'GET',
                        isArray: false,
                        params: { root: "users", dest: "GetUserForOpportunityDetails" }
                    },
                    getRegion: {
                        method: 'GET',
                        isArray: false,
                        params: { root: "users", dest: "GetUserRegionPreference" },
                        ignoreLoadingBar: true
                    },
                    updateRegion: {
                        method: 'PUT',
                        isArray: false,
                        params: { root: "users", dest: "updateRegionPreference" },
                        ignoreLoadingBar: true
                    },
                    getUsersBySameIp: {
                        method: 'GET',
                        isArray: true,
                        params: { root: "users", dest: "getUsersBySameIp" },
                        ignoreLoadingBar: true
                    },
                    updateUserPermission: {
                        method: 'PUT',
                        isArray: false,
                        params: { root: "users", dest: "updateuserpermission" },
                        cache: false
                    },
                    updateProfileVisibility: {
                        method: 'PUT',
                        isArray: false,
                        params: {root: "users", dest: "updateprofilevisibility"},
                        cache: false
                    },
                    updateUserProfileInfo: {
                        method: 'PUT',
                        isArray: false,
                        params: {root: "users", dest: "updateuserprofileinfo"},
                        cache: false
                    },
                    updateUserDetail: {
                        method: 'PUT',
                        isArray: false,
                        params: {root: "users", dest: "updateuserprofiledetail"},
                        cache: false
                    },
                    searchForTerminal: {
                        method: 'POST',
                        isArray: false,
                        params: { root: "users", dest: "searchterminaluser" },
                        cache: false,
                        interceptor: {
                            response: function (response) {
                                var result = response.resource;
                                result.$status = response.status;
                                return result;
                            }
                        }
                    },
                    addOrUpdateTerminalUser: {
                        method: 'POST',
                        isArray: false,
                        params: { root: "users", dest: "AddOrUpdateTerminalUser" },
                        cache: false
                    },
                    GetMyTerminalUsers: {
                        method: 'GET',
                        isArray: true,
                        params: { root: "users", dest: "getmyterminalusers" },
                        cache: false
                    },
                    GetTerminalUsersByOrderId: {
                        method: 'GET',
                        isArray: true,
                        params: { root: "users", dest: "getterminalusersbyorderid" },
                        cache: false
                    },
                    deleteTerminalUser: {
                        method: 'DELETE',
                        isArray: false,
                        params: { root: "users", dest: "deleteterminaluser" },
                        cache: false
                    },
                    updateUserPermissionByUserId: {
                        method: 'PUT',
                        isArray: false,
                        params: { root: "users", dest: "updateuserpermissionbyuserid" },
                        cache: false
                    },
                });
            }
        ])
        .factory('feature_access_factory', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {

                return $resource(appSettingsSvc.NEW + '/:root/:dest', {}, {
                    getListByAdmin: {
                        method: 'POST',
                        params: { root: "userfeatureaccesses", dest: "list" },
                        isArray: false,
                    },
                    getByAdmin: {
                        method: 'GET',
                        params: { root: "userfeatureaccesses", dest: "getuserfeatureaccessesbyuserid" },
                        isArray: true,
                    },
                    updateByAdmin: {
                        method: 'PUT',
                        params: { root: "userfeatureaccesses", dest: "updatebyinternalusers" },
                        isArray: false,
                    },
                    createByAdmin: {
                        method: 'POST',
                        params: { root: "userfeatureaccesses", dest: "createexternalfeatureaccess" },
                        isArray: false,
                    },
                    post: {
                        method: 'POST',
                        params: { root: "userfeatureaccesses" },
                        isArray: false,
                    },
                });
            }
        ])
        .factory('comment_factory', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NEW + '/:root/:dest', {}, {
                    create: {
                        method: 'POST',
                        params: { root: "usercomments", dest: "post" },
                        isArray: false
                    },
                    get: {
                        method: 'GET',
                        params: { root: "usercomments", dest: "getcomment" },
                        isArray: false
                    },
                    list: {
                        method: 'POST',
                        params: { root: "usercomments", dest: "list" },
                        isArray: false,
                        ignoreLoadingBar: true
                    },
                    like: {
                        method: 'POST',
                        params: { root: "usercomments", dest: "like" },
                        isArray: false,
                        ignoreLoadingBar: true
                    },
                    feedback: {
                        method: 'POST',
                        params: { root: "usercomments", dest: "feedback" },
                        isArray: false,
                        ignoreLoadingBar: true
                    },
                    delete: {
                        method: 'DELETE',
                        params: { root: "usercomments", dest: "delete" },
                        isArray: false
                    },
                    admin_list: {
                        method: 'POST',
                        params: { root: "usercomments", dest: "adminlist" },
                        isArray: false
                    },
                    status: {
                        method: 'POST',
                        params: { root: "usercomments", dest: "statusupdate" },
                        isArray: false
                    }
                });
            }
        ])
        .factory('blog_factory', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var cache = CacheFactory.get('BlogList');
                var cache2 = CacheFactory.get('BlogGet');
                var cache3 = CacheFactory.get('BlogCategory');
                return $resource(appSettingsSvc.NEW + '/blog/:dest/:root', {}, {
                    post: {
                        method: 'POST',
                        params: { dest: "" },
                        isArray: false
                    },
                    delete: {
                        method: 'DELETE',
                        params: { dest: "" },
                        isArray: false
                    },
                    list: {
                        method: 'GET',
                        params: { dest: "listv2" },
                        isArray: false,
                        cancellable: true,
                        cache: cache,
                        ignoreLoadingBar: true
                    },
                    get: {
                        method: 'GET',
                        params: { dest: "detailv2" },
                        isArray: false,
                        cache: cache2,
                        ignoreLoadingBar: true
                    },
                    category_list: {
                        method: 'GET',
                        params: { dest: "category", root: "listv2" },
                        isArray: false,
                        cache: cache3,
                        ignoreLoadingBar: true
                    },
                    category_post: {
                        method: 'POST',
                        params: { dest: "category" },
                        isArray: false
                    },
                    category_delete: {
                        method: 'DELETE',
                        params: { dest: "category" },
                        isArray: false
                    },
                    related: {
                        method: 'GET',
                        params: { dest: "relatedpostsv2" },
                        isArray: false,
                        cancellable: true,
                        ignoreLoadingBar: true
                    },
                    check_url: {
                        method: 'GET',
                        params: { dest: "checkslugavailability" },
                        isArray: false,
                        cancellable: true,
                        ignoreLoadingBar: true
                    },
                    // latest: {
                    //     method: 'GET',
                    //     params: { dest: "latestpostsv2" },
                    //     isArray: false,
                    //     cancellable: true
                    // },
                    random: {
                        method: 'GET',
                        params: { dest: "randompostsv2" },
                        isArray: false,
                        cancellable: true,
                        ignoreLoadingBar: true
                    }
                });
            }
        ])
        .factory('translate_factory', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {

                return $resource(appSettingsSvc.NEW + '/translate', {}, {
                    post: {
                        method: 'POST',
                        isArray: false
                    }
                });
            }
        ])
        .factory('mortgage_factory', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NEW + '/mortgage/:dest', {}, {
                    get: {
                        method: 'POST',
                        isArray: false,
                        params: { dest: "approve" }
                    },
                    post: {
                        method: 'POST',
                        isArray: false
                    },
                    put: {
                        method: 'PUT',
                        isArray: false
                    }
                });
            }
        ])
        .factory('akbank_mortgage_factory', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NONCACHE + '/AkbankMortgage', {}, {
                    post: {
                        method: 'POST',
                        isArray: false
                    }
                });
            }
        ])
        .factory('bank_factory', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NEW + '/:root/:dest', {}, {
                    generateBankForm: {
                        method: 'POST',
                        params: { root: 'bank', dest: 'generatebankform' },
                        isArray: false
                    }
                });
            }
        ])
        .factory('userview_factory', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NEW + '/userviewing/:dest', {}, {
                    post: {
                        method: 'POST',
                        isArray: false,
                        params: { dest: "phoneviewing" },
                        ignoreLoadingBar: true
                    },
                    get: {
                        method: 'GET',
                        isArray: false,
                        params: { dest: "phoneviewingcounts" },
                        ignoreLoadingBar: true
                    }
                });
            }
        ])
        .factory('consultancy_factory', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NEW + '/consultancy/:dest', {}, {
                    post: {
                        method: 'POST',
                        isArray: false
                    },
                    update: {
                        method: 'PUT',
                        isArray: false
                    },
                    list: {
                        method: 'POST',
                        isArray: false,
                        params: { dest: "list" },
                        cache: false,
                        ignoreLoadingBar: true
                    },
                    get: {
                        method: 'GET',
                        isArray: false,
                        cache: false
                    },
                    changeStatus: {
                        method: 'PUT',
                        isArray: false,
                        params: { dest: "changestatus" }
                    },
                    changeNote: {
                        method: 'PUT',
                        isArray: false,
                        params: { dest: "updateconsultancydescription" }
                    },
                    setAgent: {
                        method: 'PUT',
                        isArray: false,
                        params: { dest: "setagent" }
                    },
                    deleteTransaction: {
                        method: 'DElETE',
                        isArray: false,
                        params: { dest: "transaction" }
                    },
                    addTransaction: {
                        method: 'POST',
                        isArray: false,
                        params: { dest: "transaction" }
                    },
                    redirectAgents: {
                        method: 'POST',
                        isArray: false,
                        params: { dest: "assignconsultancytoagents" }
                    },
                    detailForAgent: {
                        method: 'GET',
                        isArray: false,
                        params: { dest: "getconsultancydetailsforagent" },
                        cache: false
                    },
                    myAllLeads: {
                        method: 'GET',
                        isArray: false,
                        params: { dest: "getallmyassignments" },
                        cache: false
                    },
                    closeConsultancy: {
                        method: 'PUT',
                        isArray: false,
                        params: { dest: "setconsultancystatusclosed" }
                    },
                    consultancyStatusContacted: {
                        method: 'PUT',
                        isArray: false,
                        params: { dest: "setconsultancystatuscontacted" }
                    },
                    consultancyStatusAcquired: {
                        method: 'PUT',
                        isArray: false,
                        params: { dest: "setstatussalesauthorityacquired" }
                    },
                    createLead: {
                        method: 'POST',
                        isArray: false
                    },
                    setHasContract: {
                        method: 'PUT',
                        isArray: false,
                        params: { dest: "setconsultancycontract" }
                    },
                    getConsultancyByAgentAndOwner: {
                        method: 'GET',
                        isArray: false,
                        params: { dest: "getconsultancyidsbyagentidandownerinfo", agentId: '@agentId', fingerPrint: '@fingerPrint' }
                    },
                });
            }
        ])
        .factory('segmentation_factory', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NEW + '/:root/:dest', {}, {
                    list: {
                        method: 'POST',
                        params: { root: "agents", dest: "list" },
                        isArray: false,
                        cache: false,
                        ignoreLoadingBar: true
                    },
                    changeStatus: {
                        method: 'POST',
                        params: { root: "agents", dest: "agentstatusupdate" },
                        isArray: false,
                        cache: false
                    },
                    assignSeller: {
                        method: 'POST',
                        params: { root: "agents", dest: "assignsellerforagent" },
                        isArray: false,
                        cache: false
                    },
                    detail: {
                        method: 'GET',
                        params: { root: "agents", dest: "getagentdetail" },
                        isArray: false,
                        cache: false
                    },
                    deleteNote: {
                        method: 'DELETE',
                        params: { root: "agentnotes" },
                        isArray: false,
                        cache: false
                    },
                    addNote: {
                        method: 'POST',
                        params: { root: "agentnotes" },
                        isArray: false,
                        cache: false
                    },
                    listNote: {
                        method: 'POST',
                        params: { root: "agentnotes", dest: "list" },
                        isArray: false,
                        cache: false
                    }
                });
            }
        ])
        .factory('cards_factory', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NEW + '/cards/:dest', {}, {
                    list: {
                        method: 'GET',
                        params: { dest: "list" },
                        isArray: true,
                        cache: false,
                        ignoreLoadingBar: true
                    },
                    get: {
                        method: 'GET',
                        params: { dest: "" },
                        isArray: true,
                        cache: false
                    },
                    bin: {
                        method: 'POST',
                        params: { dest: "binsearch" },
                        isArray: false
                    },
                    remove: {
                        method: 'DELETE',
                        isArray: false
                    },
                    new: {
                        method: 'POST',
                        isArray: false,
                        params: { dest: "" }
                    },
                    setAsDefault: {
                        method: 'PUT',
                        isArray: false,
                        params: { dest: "setasdefault" }
                    },
                });
            }
        ])
        .factory('company_factory', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NEW + '/company/:dest', {}, {
                    get: {
                        method: 'GET',
                        cache: false
                    },
                    update: {
                        method: 'POST',
                        isArray: false
                    },
                    relate: {
                        method: 'POST',
                        params: { dest: "relatewithuser" },
                        isArray: false
                    },
                    break_relate: {
                        method: 'POST',
                        params: { dest: "breakuserrelationship" },
                        isArray: false
                    },
                    list: {
                        method: 'POST',
                        isArray: false,
                        params: { dest: "list" },
                        ignoreLoadingBar: true
                    },
                    delete: {
                        method: 'DELETE',
                        isArray: false,
                    }
                });
            }
        ])
        .factory('orders_factory', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {
                var UserProducts = CacheFactory.get('UserProducts');
                return $resource(appSettingsSvc.NEW + '/:root/:dest', {}, {
                    post: {
                        method: 'POST',
                        params: { root: "orders" },
                        isArray: false
                    },
                    get: {
                        method: 'GET',
                        params: { root: "orders" },
                        isArray: false,
                        cache: false
                    },
                    list: {
                        method: 'POST',
                        params: { root: "orders", dest: "list" },
                        isArray: false,
                        ignoreLoadingBar: true
                    },
                    my: {
                        method: 'GET',
                        params: { root: "orders", dest: "my" },
                        isArray: false,
                        cache: false,
                        ignoreLoadingBar: true
                    },
                    complete: {
                        method: 'POST',
                        params: { root: "orders", dest: "complete" },
                        isArray: false
                    },
                    freeze: {
                        method: 'POST',
                        params: { root: "orders", dest: "freeze" },
                        isArray: false
                    },
                    changedate: {
                        method: 'POST',
                        params: { root: "orders", dest: "changepaymentduedate" },
                        isArray: false
                    },
                    fast: {
                        method: 'POST',
                        params: { root: "fastorder" },
                        isArray: false
                    },
                    calculate: {
                        method: 'POST',
                        params: { root: "orderpricecalculator" },
                        isArray: false,
                        ignoreLoadingBar: true
                    },
                    cancel: {
                        method: 'POST',
                        params: { root: "orders", dest: "cancel" },
                        isArray: false
                    },
                    user_subscriptions: {
                        method: 'GET',
                        params: { root: "subscriptions" },
                        isArray: false,
                        cache: false,
                        ignoreLoadingBar: true
                    },
                    subscriptions: {
                        method: 'GET',
                        params: { root: "subscriptions", dest: "my" },
                        isArray: false,
                        cache: false,
                        ignoreLoadingBar: true
                    },
                    subscriptionCancel: {
                        method: 'POST',
                        params: { root: "subscriptions", dest: "cancel" },
                        isArray: false
                    },
                    subscriptionCancelByAdmin: {
                        method: 'POST',
                        params: { root: "subscriptions", dest: "cancelbyadmin" },
                        isArray: false
                    },
                    subscriptionRenewError: {
                        method: 'GET',
                        params: { root: "subscriptions", dest: "getlastrenewerrorlog" },
                        isArray: false,
                        cache: false
                    },
                    subscriptionRepay: {
                        method: 'POST',
                        params: { root: "subscriptions", dest: "retrytogetpaid" },
                        isArray: false
                    },
                    orderContract: {
                        method: 'POST',
                        params: { root: "orders", dest: "setordercontract" },
                        isArray: false
                    },
                    openForPayment: {
                        method: 'POST',
                        params: { root: "orders", dest: "openforpayment" },
                        isArray: false
                    },
                    backDown: {
                        method: 'POST',
                        params: { root: "orders", dest: "backdown" },
                        isArray: false
                    },
                    addOrUpdateTags: {
                        method: 'POST',
                        params: { root: "orders", dest: "addorupdateordertags" },
                        isArray: false
                    },
                    schedule: {
                        method: 'PUT',
                        params: { root: "orders", dest: "rescheduleinstallmentdate" },
                        isArray: false
                    },
                    scheduleAll: {
                        method: 'PUT',
                        params: { root: "orders", dest: "rescheduleallinstallmentdates" },
                        isArray: false
                    },
                    getRelateds: {
                        method: 'GET',
                        params: { root: "orders", dest: "getrelatedorderssummary" },
                        isArray: true,
                        cache: false
                    },
                    getContract: {
                        method: 'GET',
                        params: { root: "orders", dest: "getordercontract" },
                        isArray: false,
                        cache: false
                    },
                    getMyContract: {
                        method: 'GET',
                        params: { root: "orders", dest: "getmyordercontract" },
                        isArray: false,
                        cache: false
                    },
                    setPaymentCouldNotBeReceived: {
                        method: 'POST',
                        params: { root: "orders", dest: "setorderstatuspaymentcouldnotbereceived" },
                        isArray: false,
                        cache: false
                    },
                    transferToIvr: {
                        method: 'POST',
                        params: { root: "orders", dest: "transferordertoivr" },
                        isArray: false,
                        cache: false
                    },
                    updateInvoice: {
                        method: 'POST',
                        params: { root: "orders", dest: "invoiceStatusUpdate" },
                        isArray: false,
                        cache: false
                    },
                    updateSeller: {
                        method: 'PUT',
                        params: { root: "orders", dest: "changeselleridfororder" },
                        isArray: false,
                        cache: false
                    },
                    setIWalletAmount: {
                        method: 'PUT',
                        params: { root: "orders", dest: "setiwalletamountfororder" },
                        isArray: false,
                        cache: false
                    },
                    updateBillingInformation: {
                        method: 'PUT',
                        params: { root: "orders", dest: "updateorderbillinginformation" },
                        isArray: false,
                        cache: false
                    },
                    myProducts: {
                        method: 'GET',
                        params: { root: "userProducts", dest: "my" },
                        isArray: false,
                        cache: UserProducts,
                        ignoreLoadingBar: true
                    },
                });
            }
        ])
        .factory('order_tags_factory', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NEW + '/:root', {}, {
                    post: {
                        method: 'POST',
                        params: { root: "tags" },
                        isArray: false
                    },
                    get: {
                        method: 'GET',
                        params: { root: "tags" },
                        isArray: true,
                        cache: false
                    },
                    delete: {
                        method: 'DELETE',
                        params: { root: "tags" },
                        isArray: false,
                        cache: false
                    }
                });
            }
        ])
        .factory('history_factory', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.HISTORY + '/userhistories', {}, {
                    set: {
                        method: 'POST',
                        isArray: false
                    }
                });
            }
        ])
        .factory('history_factory_v3', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NEW + '/userhistories', {}, {
                    get: {
                        method: 'GET',
                        isArray: true,
                        cache: false
                    }
                });
            }
        ])
        .factory('administrators_factory', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NEW + '/administrators/:dest', {}, {
                    list: {
                        method: 'POST',
                        params: { dest: "getcampaignlist" },
                        isArray: false
                    },
                    detail: {
                        method: 'POST',
                        params: { dest: "getcampaigndetail" },
                        isArray: false
                    }
                });
            }
        ])
        .factory('payment_factory', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NEW + '/payment/:dest', {}, {
                    refund: {
                        method: 'POST',
                        params: { dest: "refund" },
                        isArray: false
                    },
                    self: {
                        method: 'POST',
                        params: { dest: "payitself" },
                        isArray: false
                    },
                    team: {
                        method: 'POST',
                        params: { dest: "paybysalesteam" },
                        isArray: false
                    },
                    payWithCard: {
                        method: 'POST',
                        params: { dest: "paywithsavedcard" },
                        isArray: false
                    },
                    allowPayItSelf: {
                        method: 'POST',
                        params: { dest: "AllowPayItSelfForPaymentCouldNotBeReceivedOrder" },
                        isArray: false
                    },
                    payWithPartner: {
                        method: 'POST',
                        params: { dest: "PayWithPartner" },
                        isArray: false
                    },
                    transactions: {
                        method: 'POST',
                        params: { dest: "paymenttransactions" },
                        isArray: false
                    }
                });
            }
        ])
        .factory('notification_factory', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {
                var NotificationList = CacheFactory.get('NotificationList');
                return $resource(appSettingsSvc.NEW + '/usernotification/:dest', {}, {
                    list: {
                        method: 'GET',
                        params: { dest: "getnotifications" },
                        isArray: false,
                        cache: NotificationList,
                        ignoreLoadingBar: true
                    },
                    read: {
                        method: 'POST',
                        params: { dest: "notificationreadstatus" },
                        isArray: false
                    },
                    readAll: {
                        method: 'GET',
                        params: { dest: "notificationreadstatusforall" },
                        isArray: false
                    }
                });
            }
        ])

        .factory('user_info', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {
                var UserInfo = CacheFactory.get('UserInfo');

                return $resource(appSettingsSvc.NONCACHE + '/:dest', {}, {
                    get: {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        params: { dest: "userinfo" },
                        isArray: false,
                        cancellable: true,
                        cache: UserInfo
                    },
                    checkName: {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        params: { dest: "User" },
                        isArray: false,
                        cache: false
                    }
                });
            }
        ])
        .factory('user_check', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NONCACHE + '/:root/:dest', {}, {
                    checkName: {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        params: { root: "User", dest: "CheckName" },
                        isArray: false,
                        cache: false,
                        ignoreLoadingBar: true
                    }
                });
            }
        ])
        .factory('lead_factory', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NONCACHE + '/:dest', {}, {
                    list: {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        params: { dest: "comparablelist" },
                        isArray: false,
                        cancellable: true
                    }
                });
            }
        ])
        .factory('products_factory', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var cache = CacheFactory.get('Products');
                var cacheProductsForFilter = CacheFactory.get('Productsforfilter');
                return $resource(appSettingsSvc.NEW + '/products/:dest', {}, {
                    list: {
                        method: 'GET',
                        params: { dest: "" },
                        isArray: true,
                        cache: cache,
                        ignoreLoadingBar: true
                    },
                    listForFilter: {
                        method: 'GET',
                        params: { dest: "listingproducts" },
                        isArray: true,
                        cache: cacheProductsForFilter,
                        ignoreLoadingBar: true
                    }
                });

            }
        ])
        .factory('promo_factory', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NEW + '/promo/:dest', {}, {
                    list: {
                        method: 'GET',
                        params: { dest: "list" },
                        isArray: false,
                        cache: false
                    },
                    create: {
                        method: 'POST',
                        params: { dest: "" },
                        isArray: false
                    },
                    get: {
                        method: 'GET',
                        isArray: false,
                        cache: false
                    },
                    delete: {
                        method: 'DELETE'
                    },
                    validate: {
                        method: 'POST',
                        params: { dest: "checkpromocodeusability" },
                        isArray: false
                    }

                });
            }
        ]).factory('logo_factory', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NEW + '/erp/:dest', {}, {
                    get: {
                        method: 'POST',
                        params: { orderId: '@orderId' },
                        cache: false
                    },
                    sendInvoiceEmail: {
                        method: 'POST',
                        params: { dest: 'SendOrderInvoiceEmail', orderId: '@orderId' },
                        cache: false
                    }
                });
            }
        ]).factory('zoho_factory', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NEW + '/orderzoho/:dest', {}, {
                    getDeals: {
                        method: 'GET',
                        params: { dest: 'getdealsbyuserid' },
                        cache: false,
                        isArray: false
                    },
                    matchDeal: {
                        method: 'GET',
                        params: { dest: 'matchorderwithdealid' },
                        cache: false,
                        isArray: false
                    }
                });
            }
        ]);
})();
